module.exports = __webpack_public_path__ + "media/headRight1.cce0b0ee.mp4";